<template>
  <main class="main userDeleteGuide" role="main">
    <div class="main_con">
      <h1 class="ttl">퍼스 계정 삭제 안내</h1>
      <div class="con">
        <div class="con_txt_1">
          <div class="txt_1">
            <img src="@/assets/front/images/img_customer_app_icon.png" alt="" />
          </div>
          <div class="txt_2">퍼스-인터넷가입 비교 플랫폼</div>
        </div>
        <div class="con_txt_2">
          <div class="txt_1">계정 삭제 요청 단계</div>
          <div class="txt_2">
            <ul>
              <li>1. 퍼스 로그인</li>
              <li>
                2. 메인 상단에 마이페이지(<img
                  src="@/assets/front/images/new/i_h_my.svg"
                  alt=""
                />) 선택
              </li>
              <li>
                3. 닉네임 옆 설정(<img
                  src="@/assets/front/images/new/gear_six_grey.svg"
                  alt=""
                />) 선택
              </li>
              <li>4. 설정 하단에 탈퇴하기 선택</li>
            </ul>
          </div>
        </div>
        <div class="con_txt_3">
          <div class="txt_1">※ 탈퇴 즉시 사용자 계정은 삭제됩니다.</div>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button class="btn" @click="goLogin">
            퍼스 로그인 하러 가기
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  components: {},
  name: '',
  created() {},
  data() {
    return {};
  },
  async mounted() {},
  computed: {},
  methods: {
    goLogin() {
      this.$router.push({ name: 'Auth.Login' });
    },
  },
};
</script>

<style lang="scss" scoped>
.userDeleteGuide {
  width: 100%;
  max-width: 620px;
  margin: auto;
  background-color: #edf0f6;
  .main_con {
    padding: 5rem 0;

    .ttl {
      font-size: 3rem;
      font-weight: 700;
      text-align: center;
    }

    .con {
      padding: 5rem;
      .con_txt_1 {
        display: flex;
        align-items: center;
        // justify-content: center;
        margin-bottom: 3rem;
        .txt_1 {
          margin-right: 0.5rem;
          img {
            border: 1px solid #cccccc;
            border-radius: 0.7rem;
            width: 5rem;
            height: auto;
          }
        }
        .txt_2 {
          font-size: 1.5rem;
          font-weight: 500;
        }
      }

      .con_txt_2 {
        margin-bottom: 3rem;
        .txt_1 {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }
        .txt_2 {
          ul {
            li {
              font-size: 1.5rem;
              margin-bottom: 0.3rem;
              img {
                display: inline;
                width: 2rem;
                height: auto;
                vertical-align: middle;
              }
            }
          }
        }
      }

      .con_txt_3 {
        margin-bottom: 3rem;
        .txt_1 {
          font-size: 1.5rem;
          font-weight: 500;
          margin-bottom: 1rem;
        }
      }
    }
  }
}
</style>
